var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',[_vm._v("\n  Ends in "+_vm._s(_vm.toString(_vm.days))+"d "+_vm._s(_vm.hours)+"h "+_vm._s(_vm.minutes)+"m "+_vm._s(_vm.seconds)+"s\n")]):_c('div',[_vm._v("\n  Ended on "+_vm._s(_vm.formatDate(_vm.date))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }